import { helper } from "@/helper";

export default {
  //   data: () => ({}),
  methods: {
    isStudentIdExist() {
      let userCookie = helper.getUserCookie();
      // if (process.env.VUE_APP_ISDEBUGGING)
      //   console.log("isStudentIdExist() usercookie", userCookie);

      if (userCookie && userCookie.userName) {
        return true;
      }

      return false;
    },
  },
  computed: {
    studentId() {
      let userCookie = helper.getUserCookie();

      if (userCookie == null) return "";
      return userCookie.userName != null ? userCookie.userName : "";
    },
    firstName() {
      let userCookie = helper.getUserCookie();
      if (userCookie == null) return "";
      return userCookie.firstName ? userCookie.firstName : userCookie.givenname;
    },
    phonenum() {
      let userCookie = helper.getUserCookie();

      if (userCookie == null) return "";
      return userCookie.mobile != null ? userCookie.mobile : "";
    },
  },
};
